import api from '@/apis'
import { mockDelay } from '@/apis/mockDelay'
import { IS_MOCK } from '@/constants'
import type { MissionsResponse } from '@/types/mission'

import { MOCK_MISSIONS } from './mocks'

export const apiGetMissions = async (): Promise<MissionsResponse> => {
  if (IS_MOCK) {
    await mockDelay()
    return MOCK_MISSIONS
  }
  return await api.get<MissionsResponse>('/missions')
}
